import { applyChangesToElements, Change, UserVersion } from '@ritabygglov/core';
import { copy } from '../../helpers/utility';
import { AppState } from '../../types';
import { IStateSynchronizer } from './IStateSynchronizer';

export class CRDTSynchronizer implements IStateSynchronizer {
  // Tombstone map: retains the last-seen version for every element, including deleted ones.
  // appState.elements[id] is removed on deletion, but elementVersions[id] is kept so that
  // out-of-order or re-submitted changes with an older version cannot resurrect the element.
  // A higher-version change (e.g. undo) still passes the isNewerVersion check and restores it.
  private elementVersions: { [elementId: string]: UserVersion } = {};

  constructor(
    private readonly setAppState: React.Dispatch<
      React.SetStateAction<AppState>
    >,
    private readonly onLocalChanges?: (changes: Change[]) => void,
    private readonly useTombstone: boolean = false
  ) {}

  applyLocalChanges(changes: Change[]): void {
    this.applyChanges(changes);
    this.onLocalChanges?.(changes);
  }

  applyRemoteChanges(changes: Change[]): void {
    this.applyChanges(changes);
  }

  getElementVersion(elementId: string): UserVersion | undefined {
    return this.elementVersions[elementId];
  }

  private applyChanges(changes: Change[]): void {
    this.setAppState((oldAppState) => {
      const appState = copy(oldAppState);

      applyChangesToElements(appState.elements, this.elementVersions, changes, {
        useTombstone: this.useTombstone,
      });

      return appState;
    });
  }
}
